<template>
  <TheGreyWrapper v-if="opportunity">
    <TheHeader
      back-route="."
    />
    <BaseSection>
      <BaseTitleGroup
        :subtitle="opportunity.data.attributes.name"
        :title="$t('Amount confirmation')"
        class="mb-4"
      />
      <BaseWarningBox class="mb-8">
        {{ $t('Investment accepted details') }}
        <span class="font-heavy text-black">
          {{ currentUserWish.attributes.acceptedAmount | currency({fractionCount: 2}) }}
        </span>
      </BaseWarningBox>
      <BaseButton
        :title="$t('Complete my information')"
        to="investment-entities"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseWarningBox from '../components/BaseWarningBox.vue';
import BaseButton from '../components/BaseButton.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';

export default {
  name: 'OpportunityAccept',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseWarningBox,
    BaseButton,
    TheGreyWrapper,
  },
  mixins: [loadOpportunity],
};
</script>
